<template>
    <div class="upload-file">
        <el-upload :action="uploadFileUrl" :before-upload="handleBeforeUpload" :file-list="fileList" :limit="limit" :on-error="handleUploadError" :on-exceed="handleExceed" :on-success="handleUploadSuccess" :show-file-list="false" :headers="headers" class="upload-file-uploader" ref="upload">
            <!-- 上传按钮 -->
            <el-button size="mini" type="primary">选取文件</el-button>
            <!-- 上传提示 -->
            <div class="el-upload__tip" style="line-height: 1.5" slot="tip" v-if="showTip">
                请上传
                <template v-if="fileSize"> 大小不超过 <b style="color: #f56c6c">{{ fileSize }}MB</b> </template>
                <template v-if="fileType"> 格式为 <b style="color: #f56c6c">{{ fileType.join("/") }}</b> </template>
                的文件
                <br>
                <template v-if="notice">{{ notice }}</template>
            </div>
        </el-upload>

        <!-- 文件列表 -->
        <div class="upload-file-list el-upload-list el-upload-list--text" name="el-fade-in-linear" tag="ul" v-if="isShowFileList">
            <li :key="file.uid" class="el-upload-list__item ele-upload-list__item-content" v-for="(file, index) in fileList">
                <el-link :href="`${file.url}`" :underline="false" target="_blank" class="ele-upload-list__item-content-name">
                    <span class="el-icon-document ellipsis"> {{ file.name }} </span>
                </el-link>
                <div class="ele-upload-list__item-content-action">
                    <el-link :underline="false" @click="handleDelete(index)" type="danger">删除</el-link>
                </div>
            </li>
        </div>
    </div>
</template>

<script>
import { getToken } from "@/utils/auth";
import { showToast } from "@/utils/toast.js"
import { Loading } from 'element-ui';

export default {
    name: "FileUpload",
    props: {
        // 值
        value: [String, Object, Array],
        // 数量限制
        limit: {
            type: Number,
            default: 5,
        },
        // 大小限制(MB)
        fileSize: {
            type: Number,
            default: 5,
        },
        // 文件类型, 例如['png', 'jpg', 'jpeg']
        fileType: {
            type: Array,
            default: () => ["doc", "xls", "ppt", "txt", "pdf"],
        },
        // 是否显示提示
        isShowTip: {
            type: Boolean,
            default: true
        },
        isShowFileList: {
            type: Boolean,
            default: true,
        },
        notice: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            baseUrl: process.env.VUE_APP_BASE_API,
            uploadFileUrl: process.env.VUE_APP_BASE_API + "/resource/oss/upload", // 上传的图片服务器地址
            headers: {
                Authorization: "Bearer " + getToken(),
                Clientid: process.env.VUE_APP_CLIENT_ID,
            },
            fileList: [],
            LoadingInstance: null,
        };
    },
    watch: {
        value: {
            handler(val) {
                if (val) {
                    let temp = 1;
                    // 首先将值转为数组
                    const list = Array.isArray(val) ? val : this.value.split(',');
                    // 然后将数组转为对象数组
                    this.fileList = list.map(item => {
                        if (typeof item === "string") {
                            item = { name: item, url: item };
                        }
                        item.uid = item.uid || new Date().getTime() + temp++;
                        return item;
                    });
                } else {
                    this.fileList = [];
                    return [];
                }
            },
            deep: true,
            immediate: true
        }
    },
    computed: {
        // 是否显示提示
        showTip() {
            return this.isShowTip && (this.fileType || this.fileSize);
        },
    },
    methods: {
        // 上传前校检格式和大小
        handleBeforeUpload(file) {
            // 校检文件类型
            if (this.fileType) {
                let fileExtension = "";
                if (file.name.lastIndexOf(".") > -1) {
                    fileExtension = file.name.slice(file.name.lastIndexOf(".") + 1);
                }
                const isTypeOk = this.fileType.some((type) => {
                    if (file.type.indexOf(type) > -1) return true;
                    if (fileExtension && fileExtension.indexOf(type) > -1) return true;
                    return false;
                });
                if (!isTypeOk) {
                    showToast({
                        icon: "error",
                        title: `文件格式不正确, 请上传${this.fileType.join("/")}格式文件!`
                    })
                    return false;
                }
            }
            // 校检文件大小
            if (this.fileSize) {
                const isLt = file.size / 1024 / 1024 < this.fileSize;
                if (!isLt) {
                    showToast({
                        icon: "error",
                        title: `上传文件大小不能超过 ${this.fileSize} MB!`
                    })
                    return false;
                }
            }

            this.LoadingInstance = Loading.service({
                lock: true,
                text: "文件上传中...",
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            return true;
        },
        // 文件个数超出
        handleExceed() {
            showToast({
                icon: "error",
                title: `上传文件数量不能超过 ${this.limit} 个!`
            })
        },
        // 上传失败
        handleUploadError(err) {
            this.LoadingInstance.close();
            showToast({
                icon: "error",
                title: `上传失败, 请重试`
            })
        },
        // 上传成功回调
        handleUploadSuccess(res, file) {
            this.LoadingInstance.close();
            if (res.code == 200) {
                showToast({
                    icon: "success",
                    title: `上传成功`
                })
                this.fileList.push({ name: res.data.fileName, url: res.data.url });
                this.$emit("input", this.listToString(this.fileList));
                this.$emit("success", res.data);
            } else {
                showToast({
                    icon: "error",
                    title: `上传失败, 请重试`
                })
            }
        },
        clearFileList() {
            this.fileList = [];
        },
        // 删除文件
        handleDelete(index) {
            this.fileList.splice(index, 1);
            this.$emit("input", this.listToString(this.fileList));
        },
        // 获取文件名称
        getFileName(name) {
            if (name.lastIndexOf("/") > -1) {
                return name.slice(name.lastIndexOf("/") + 1).toLowerCase();
            } else {
                return "";
            }
        },
        // 对象转成指定字符串分隔
        listToString(list, separator) {
            let strs = "";
            separator = separator || ",";
            for (let i in list) {
                strs += list[i].url + separator;
            }
            return strs != '' ? strs.substr(0, strs.length - 1) : '';
        }
    }
};
</script>

<style lang="scss">
.ele-upload-list__item-content-name.el-link {
    margin-right: 12px;
    overflow: hidden;

    .el-link--inner {
        overflow: hidden;

        .el-icon-document {
            width: 100%;
        }
    }
}
</style>

<style scoped lang="scss">
.upload-file-uploader {
    margin-bottom: 5px;
}
.upload-file-list .el-upload-list__item {
    border: 1px solid #e4e7ed;
    line-height: 2;
    margin-bottom: 10px;
    position: relative;
}
.upload-file-list .ele-upload-list__item-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 6px;
    color: inherit;
    overflow: hidden;
}

.ele-upload-list__item-content-action {
    flex: 0 0 auto;
}
</style>